/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material

// styles
import injectSheet from 'react-jss';
import styles from 'material/expandablesection/sectioncard/sectioncard_styles';


const SectionCard = (props) => {
  const { title } = props
  return <div className={`sectioncard ${props.classes.sectioncard}`}>
    {title && <h2>{title}</h2>}
    {props.children}
  </div>
}

export default injectSheet(styles)(SectionCard)